import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal } from "@air/primitive-modal";
import { useCallback } from "react";
import { SamlSSOLoginForm } from "~/components/Auth/SamlSSOLoginForm";
import { AirModalLogoHeader } from "~/components/Modals/AirModalLogoHeader";
import { saveSSOCallbackData } from "~/components/PublicSSOCallback/utils";
export const SamlSSOLoginModal = (param)=>{
    let { onShowLoginClick, onClose, ssoCallbackData, customState } = param;
    const saveRedirectData = useCallback(()=>{
        // save data about action to perform when user signs in using SSO
        if (ssoCallbackData) {
            saveSSOCallbackData(ssoCallbackData);
        }
    }, [
        ssoCallbackData
    ]);
    const showLogin = useCallback(()=>{
        onClose();
        setTimeout(onShowLoginClick, 200);
    }, [
        onClose,
        onShowLoginClick
    ]);
    return /*#__PURE__*/ _jsxs(Modal, {
        className: "w-[414px] p-8",
        isOpen: true,
        onDismiss: onClose,
        children: [
            /*#__PURE__*/ _jsx(AirModalLogoHeader, {
                onClose: onClose
            }),
            /*#__PURE__*/ _jsx("h1", {
                className: "mb-4 text-center text-20 font-semibold text-pigeon-700",
                children: "Log in with SAML SSO"
            }),
            /*#__PURE__*/ _jsx(SamlSSOLoginForm, {
                customState: customState,
                onContinueWithPasswordClick: showLogin,
                onRedirect: saveRedirectData
            })
        ]
    });
};
